import shiftSwapHourDiffIndicatorUrl from './shift-swap-hour-diff-indicator.html';

class ShiftSwapHourDiffIndicatorCtrl {
  get hourDiff() {
    if (!this.swap) {
      return '';
    }
    const { offereeShift, offererShift } = this.swap;
    const difference = offereeShift.duration - offererShift.duration;
    const sign = difference > 0 ? '+' : '-';
    return difference === 0 ? 0 : `${sign}${difference}`;
  }

  get diffDescription() {
    const { amIOfferee } = this.exchangeData;
    return `Difference in hours from ${
      amIOfferee ? 'your' : this.swap.offereeShift.user.fullname
    } original shift`;
  }
}

export default {
  controller: ShiftSwapHourDiffIndicatorCtrl,
  controllerAs: 'ctrl',
  bindings: {
    swap: '<',
    exchangeData: '<',
  },
  templateUrl: shiftSwapHourDiffIndicatorUrl,
};
